module.exports = __webpack_public_path__ + "static/media/13.d8b0bbf0.jpg";